import { render, staticRenderFns } from "./2_officer.vue?vue&type=template&id=25926574&scoped=true&"
import script from "./2_officer.vue?vue&type=script&lang=js&"
export * from "./2_officer.vue?vue&type=script&lang=js&"
import style0 from "./2_officer.vue?vue&type=style&index=0&id=25926574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25926574",
  null
  
)

export default component.exports